import image from "./../../assets/software_development.gif";
import imageTelaDeRegistro from "./../../assets/imageTelaDeRegistro.png";
import styles from "./styles.module.scss";
import { Input } from "@mui/base/Input";
import { useEffect, useState } from "react";
import {
  createTenant,
  verifyIfTenantExists,
} from "../../services/api/tenant/TenantService";
import { storageSelectedTenantSave } from "../../storage/storageSelectedTenant";
import { TUserInfo } from "../../@types/user-info.type";
import { ICreateTenant } from "../../@types/create-tenant.type";
import { migrate } from "../../services/api/migration/MigrationService";
import {
  addUserToGroup,
  ensureUser,
} from "../../services/api/user/UserService";
import { IUserInformation } from "../../@types/user-information.type";
import { GroupStatic } from "../../@types/statics/group.static";
import Button from "@mui/material/Button";
import { useKeycloak } from "@react-keycloak/web/lib/useKeycloak";

export function NewTenant() {
  const [loading, setLoading] = useState<boolean>();
  const [isTenantNameValid, setIsTenantNameValid] = useState<boolean>(false);
  const [globalLoading, setGlobalLoading] = useState<boolean>();
  const [message, setMessage] = useState<string>();
  const [tenantName, setTenantName] = useState<string>();
  const [helperText, setHelperText] = useState<string>("");
  const [tenantNameAlreadyExists, setTenantNameAlreadyExists] =
    useState<boolean>(false);
  const { keycloak, initialized } = useKeycloak();
  const format = /^[a-zA-Z0-9]*$/;

  const handleAddTenantClick = async () => {
    setGlobalLoading(true);
    setMessage("Criando sua conta...");
    storageSelectedTenantSave(tenantName as string);
    const user = (await keycloak.loadUserInfo()) as TUserInfo;
    const createTenantObj: ICreateTenant = {
      account: {
        email: user.email,
      },
      tenant: {
        tenantName: tenantName as string,
      },
    };
    await createTenant(createTenantObj);
    setMessage("Carregando os dados iniciais...");
    await migrate();
    let userInformation: IUserInformation = {
      firstname: user.given_name,
      lastname: user.family_name,
      email: user.email,
    };
    setMessage("Criando usuário...");
    userInformation = await ensureUser(userInformation);
    setMessage("Atribuindo permissões ao usuário...");
    addUserToGroup(userInformation.id as string, GroupStatic.administrators.id);
    storageSelectedTenantSave(tenantName as string);
    setTimeout(async () => {
      window.location.href = "/";
    }, 1000);
  };

  useEffect(() => {
    if (!tenantName || tenantName.length <= 3) {
      setIsTenantNameValid(false);
      setHelperText("");
    } else if (!format.test(tenantName)) {
      setIsTenantNameValid(false);
      setHelperText(
        "O nome da conta deve conter mais que 3 caracteres e não pode conter espaços, nem acentos."
      );
    } else {
      setIsTenantNameValid(true);
      setHelperText("");
      const timeOutId = setTimeout(async () => {
        try {
          setLoading(true);
          const result = await verifyIfTenantExists(tenantName);
          storageSelectedTenantSave(tenantName);
          setTenantNameAlreadyExists(result);
          if (result) {
            setHelperText("Conta já existe.");
          }
          setLoading(false);
        } catch (error) {
          console.log(error)
          setLoading(false);
        }
      }, 500);
      return () => clearTimeout(timeOutId);
    }
  }, [tenantName]);

  return (
    <main className={styles.newTenant}>
      {!globalLoading ? (
        <>
          <div className={styles.container}>
            <div className={styles.left} style={{ flex: 1 }}>
              <div
                style={{
                  backgroundColor: "black",
                  height: "100vh",
                  marginRight: "-30px",
                }}
              >
                <img
                  src={imageTelaDeRegistro}
                  style={{ height: "100%" }}
                  alt="Imagem Login"
                />
              </div>
            </div>

            <div className={styles.right}>
              <div>
                <h3>Nova conta</h3>
                <Input
                  className={styles.fieldInput}
                  aria-label="Demo input"
                  placeholder="Nome da conta..."
                  error={
                    tenantName != undefined &&
                    (tenantNameAlreadyExists || !isTenantNameValid)
                  }
                  type="text"
                  value={tenantName}
                  onChange={(event) => setTenantName(event.target.value)}
                />
                <span
                  style={{
                    marginBottom: "2rem",
                    fontSize: "12px",
                    color: "#f05656",
                  }}
                >
                  {helperText}
                </span>

                <Button
                  className={styles.btn}
                  variant="contained"
                  color="primary"
                  onClick={handleAddTenantClick}
                  disabled={
                    !isTenantNameValid || tenantNameAlreadyExists || loading
                  }
                >
                  Criar conta
                </Button>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <h2>Aguarde um pouco, que estamos preparando tudo pra você...</h2>
          <img src={image} alt="" style={{ width: "500px", margin: "55px" }} />
          <h3>{message}</h3>
        </>
      )}
    </main>
  );
}
